<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active.sync="performingRequest"
      :can-cancel="true"
    ></b-loading>
    <div
      class="columns is-multiline"
      v-if="localPosts && localPosts.length"
    >
      <BlogPostsCard
        v-for="(post, indx) in localPosts"
        :key="indx"
        :post="post"
        :showAuthor="showAuthor"
        :class="classes ? classes : 'column'"
      ></BlogPostsCard>
    </div>
    <div v-else>
      <h3>Nenhuma Publicação Encontrada</h3>
    </div>
  </div>
</template>

<script>
import BlogPostsCard from './BlogPostsCard'
import { getAllPostsMixin, getPostsFromAuthorMixin } from '../../mixins/posts.methods'
export default {
  props: {
    classes: String,
    posts: {
      type: Array
    },
    authorId: {
      type: String
    },
    showAuthor: {
      type: Boolean
    },
    maxResults: {
      type: Number
    }
  },
  components: {
    BlogPostsCard
  },
  mixins: [getAllPostsMixin, getPostsFromAuthorMixin],
  data () {
    return {
      localPosts: [],
      performingRequest: false
    }
  },
  mounted () {
    this.localPosts =
      this.posts ||
      this.getPostsFromAuthor(this.authorId) ||
      this.getAllPosts()
  }
}
/**
 * @todo linkar o numero máximo de resultados a um painel de configurações
 */
</script>
